class AlwaysOnReactivation extends HTMLElement {
  constructor() {
    super();

    this.alreadyClaimedScreen = this.querySelector('#screen_0');
    this.reactProductsScreen = this.querySelector('#screen_1');
    this.reactGiftsScreen = this.querySelector('#screen_2');

    this.drawerDialog = this.querySelector('drawer-dialog');
    this.drawerContents = this.querySelector('#drawer-contents');

    this.submitButton = this.querySelector('.submit');
    this.showReactGiftsButton = this.querySelectorAll('.show_gift_button');
    this.showReactProductsButton = this.querySelector('.back');

    this.giftDiscountCode = this.submitButton.dataset.giftDiscountCode;
    this.reactProductDiscountCode = this.submitButton.dataset.reactDiscountCode;

    this.selectedFrequency = 1;

    this.reactProduct = {
      price: null,
      variantId: null,
      sellingPlanIds: null,
      discountedPrice: null,
    };

    this.reactGift = {
      price: null,
      variantId: null,
      discountedPrice: 0,
    };

    this.modalProductData = {
      price: null,
      variantId: null,
      sellingPlanId: null,
      discountedPrice: null,
    };

    this.infoModal = document.querySelector('modal-dialog#Full-info');
  }

  connectedCallback() {
    // Nick: Temporarily disabling due to complaints
    // this.#alreadyClaimedSafeGuard();
    this.#addEventListeners();
    this.#fireEvent('bogof_subscription_product_grid', 'view_page', 'Subscription products');
  }

  #addEventListeners() {
    this.reactProductsScreen
      .querySelectorAll('.reactivation__react-product .reactivation__product-money_and_button .button')
      .forEach((button) =>
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.#eventSelectReactProduct(button.closest('#product_card'));
        }),
      );

    this.reactGiftsScreen.querySelectorAll('.reactivation__free-product .button').forEach((button) =>
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.#eventSelectFreeProduct(button.closest('#product_card'));
      }),
    );

    this.reactProductsScreen.querySelectorAll('#product_card').forEach((card) => {
      card.addEventListener('click', () => this.#eventReactProductReadmore(card));
    });

    this.reactGiftsScreen.querySelectorAll('#product_card').forEach((card) => {
      card.addEventListener('click', () => this.#eventFreeProductReadmore(card));
    });

    this.drawerContents.querySelector('select').addEventListener('change', (event) => {
      this.selectedFrequency = event.target.value;
      this.#fireEvent('bogof_bottom_drawer', 'change_frequency', this.selectedFrequency);
    });

    this.showReactGiftsButton.forEach((button) => {
      button.addEventListener('click', () => {
        this.#showReactGiftsScreen();
        this.drawerDialog.closeDrawer();
      });
    });

    this.showReactProductsButton.addEventListener('click', () => {
      this.reactGift.variantId = null;
      this.#showReactProductsScreen();
    });

    this.submitButton.addEventListener('click', () => {
      this.#addToCart();
      this.#fireEvent('bogof_bottom_drawer', 'reactivate', this.selectedFrequency);
    });

    this.infoModal.querySelector('button.button').addEventListener('click', () => {
      this.#selectProduct(this.modalProductData);

      this.infoModal.click();
    });
  }

  #eventSelectReactProduct(button) {
    this.reactProductAlreadyDiscounted = button.dataset.alreadyDiscounted == 'true';

    this.reactProduct = {
      price: button.dataset.price,
      variantId: button.dataset.variantId,
      discountedPrice: button.dataset.discountedPrice,
      nextProductVariantId: button.dataset.nextProductVariantId,
      sellingPlanIds: Array.from(button.attributes).filter((attribute) =>
        attribute.name.includes('data-selling-plan-id-'),
      ),
    };

    this.#selectProduct(this.reactProduct);
  }

  #eventSelectFreeProduct(button) {
    this.reactGift = {
      price: button.dataset.price,
      variantId: button.dataset.variantId,
      discountedPrice: null,
    };

    this.#selectProduct(this.reactGift);
  }

  #eventReactProductReadmore(button) {
    const openModalButton = this.querySelector('modal-opener button');

    const modalImage = this.infoModal.querySelector('img');
    modalImage.src = button.dataset.image;
    modalImage.alt = `${button.dataset.title} image`;

    this.infoModal.querySelector('h3.title').textContent = button.dataset.title;
    this.infoModal.querySelector('div.description').textContent = button.dataset.description;

    const fullPriceElement = this.infoModal.querySelector('.full-price');
    fullPriceElement.innerHTML = button.dataset.price;

    const notDiscounted =
      button.dataset.alreadyDiscounted == 'true' || button.dataset.discountedPrice == button.dataset.price;
    if (notDiscounted) {
      fullPriceElement.classList.remove('translucent-strikethrough');
      this.infoModal.querySelector('.discounted-price').classList.add('hidden');
    } else if (button.dataset.discountedPrice) {
      fullPriceElement.classList.add('translucent-strikethrough');
      this.infoModal.querySelector('.discounted-price').classList.remove('hidden');
      this.infoModal.querySelector('.discounted-price').innerHTML = button.dataset.discountedPrice;
    }

    this.reactProduct = {
      price: button.dataset.price,
      variantId: button.dataset.variantId,
      discountedPrice: button.dataset.discountedPrice,
      sellingPlanIds: Array.from(button.attributes).filter((attribute) =>
        attribute.name.includes('data-selling-plan-id-'),
      ),
    };

    this.modalProductData = this.reactProduct;

    openModalButton.click();
  }

  #eventFreeProductReadmore(button) {
    const openModalButton = this.querySelector('modal-opener button');

    const modalImage = this.infoModal.querySelector('img');
    modalImage.src = button.dataset.image;
    modalImage.alt = `${button.dataset.title} image`;

    this.infoModal.querySelector('h3.title').textContent = button.dataset.title;
    this.infoModal.querySelector('div.description').textContent = button.dataset.description;

    const fullPriceSpan = this.infoModal.querySelector('.full-price');
    fullPriceSpan.innerHTML = button.dataset.price;
    fullPriceSpan.classList.add('translucent-strikethrough');

    this.infoModal.querySelector('.discounted-price').classList.add('hidden');

    this.reactGift = {
      price: button.dataset.price,
      variantId: button.dataset.variantId,
      discountedPrice: 0,
    };

    this.modalProductData = this.reactGift;

    openModalButton.click();
  }

  #selectProduct(data) {
    if (data.sellingPlanIds != null) {
      this.#selectReactProduct(data);
      this.#fireEvent('bogof_subscription_product_grid', 'add_to_cart', this.reactProduct.variantId);
    } else {
      this.#selectReactGift(data);
      this.#fireEvent('bogof_free_product_grid', 'add_to_cart', this.reactGift.variantId);
    }
    this.drawerDialog.openDrawer();
  }

  #selectReactProduct(data) {
    this.reactProduct.variantId = data.variantId;
    this.reactProduct.sellingPlanIds = data.sellingPlanIds;
    this.nextProductVariantId = data.nextProductVariantId;

    this.#drawerUpdateReactGift();
    this.#drawerIncompleteState();
  }

  #selectReactGift(data) {
    this.reactGift.variantId = data.variantId;

    this.#drawerUpdateReactGift();
    this.#drawerCompleteState();
  }

  async #addToCart() {
    this.submitButton.setAttribute('disabled', 'disabled');
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      const signupConfig = {
        mainProduct: {
          variantId: this.reactProduct.variantId,
          sellingPlanId: this.reactProduct.sellingPlanIds[this.selectedFrequency - 1].value,
        },
        addonProduct: {
          variantId: this.reactGift.variantId,
        },
        ...(this.reactProductDiscountCode && !this.reactProductAlreadyDiscounted
          ? { discountCode: this.reactProductDiscountCode }
          : {}),
        ...(this.giftDiscountCode ? { addonDiscountCode: this.giftDiscountCode } : {}),
        ...(this.nextProductVariantId ? { nextProduct: { variantId: this.nextProductVariantId } } : {}),
      };

      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, true);
      this.#alreadyClaimedStatusUpdate();
    } catch (error) {
      console.log('Error adding to cart:', error);
    } finally {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.classList.remove('loading');
      this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  #showReactProductsScreen() {
    this.reactProductsScreen.classList.remove('hidden');
    this.reactGiftsScreen.classList.add('hidden');
    this.#scrollToTop();
  }

  #showReactGiftsScreen() {
    this.reactProductsScreen.classList.add('hidden');
    this.reactGiftsScreen.classList.remove('hidden');
    this.#scrollToTop();
    this.#fireEvent('bogof_free_product_grid', 'view_page', 'Gift page');
  }

  #drawerIncompleteState() {
    this.drawerContents.querySelector('.show_gift_button').classList.remove('hidden');
    this.drawerContents.querySelector('.show_gifts').classList.remove('hidden');
    this.drawerContents.classList.remove('complete-only');
    this.drawerContents.classList.add('incomplete-only');

    this.#drawerFilterFrequencies();
    this.#drawerUpdateReactProduct();
  }

  #drawerCompleteState() {
    this.drawerContents.querySelector('.show_gift_button').classList.add('hidden');
    this.drawerContents.querySelector('.show_gifts').classList.add('hidden');
    this.drawerContents.classList.add('complete-only');
    this.drawerContents.classList.remove('incomplete-only');

    this.#drawerUpdatePrices();
  }

  #drawerUpdateReactProduct() {
    this.drawerContents.querySelectorAll('.selected-sub-product').forEach((product) => {
      if (product.dataset.variantId == this.reactProduct.variantId) {
        product.classList.remove('hidden');
      } else {
        product.classList.add('hidden');
      }
    });
  }

  #drawerUpdateReactGift() {
    this.drawerContents.querySelectorAll('.selected-free-product').forEach((product) => {
      if (product.dataset.variantId == this.reactGift.variantId) {
        product.classList.remove('hidden');
      } else {
        product.classList.add('hidden');
      }
    });
  }

  #drawerFilterFrequencies() {
    const valuesToAdd = [
      { id: 'monthly', value: 1, textContent: 'Monthly' },
      { id: 'bimonthly', value: 2, textContent: 'Bimonthly' },
      { id: 'quarterly', value: 3, textContent: 'Quarterly' },
    ];

    const frequencySelect = this.drawerContents.querySelector('select#frequencies');
    frequencySelect.replaceChildren();

    this.reactProduct.sellingPlanIds.forEach((id, index) => {
      const option = document.createElement('option');
      option.id = valuesToAdd[index].id;
      option.value = valuesToAdd[index].value;
      option.textContent = valuesToAdd[index].textContent;

      frequencySelect.appendChild(option);
    });
  }

  #drawerUpdatePrices() {
    const reactPrice = parseFloat(this.reactProduct.price.replace('£', ''));
    const reactDiscountPrice = parseFloat(this.reactProduct.discountedPrice.replace('£', ''));
    const giftPrice = parseFloat(this.reactGift.price.replace('£', ''));
    const giftDiscountPrice = this.reactGift.discountedPrice;

    this.drawerContents.querySelector('#total-price').textContent = `£${reactDiscountPrice.toFixed(2)}`;
    this.drawerContents.querySelector('#savings-price').textContent =
      `-£${(reactPrice - reactDiscountPrice + giftPrice).toFixed(2)}`;
    this.drawerContents.querySelector('#subtotal-price').textContent = `£${(reactPrice + giftPrice).toFixed(2)}`;
  }

  #fireEvent(eventContext, eventAction, eventValue) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'site_interaction',
      context: eventContext,
      action: eventAction,
      value: eventValue,
    });
  }

  #alreadyClaimedSafeGuard() {
    const status = this.#alreadyClaimedVerification();

    if (!status.possiblyClaimed) {
      return;
    }

    const offerInCart = this.#checkOfferStillInCart();
    this.alreadyClaimedScreen.classList.remove('hidden');
    this.reactProductsScreen.classList.add('hidden');

    if (offerInCart) {
      this.#openCartDrawer();
    }
  }

  #alreadyClaimedVerification() {
    const claimedDateString = window.localStorage.getItem('bogof_claimed');
    if (!claimedDateString) {
      return { possiblyClaimed: false };
    }
    return { possiblyClaimed: true };
  }

  #alreadyClaimedStatusUpdate() {
    window.localStorage.setItem('bogof_claimed', `${new Date()}`);
  }

  #checkOfferStillInCart() {
    const cartDrawer = document.querySelector('cart-drawer.drawer');
    const discounts = cartDrawer?.querySelectorAll('.discounts__discount');

    const containsOfferDiscountCode = Array.from(discounts).some(
      (element) =>
        element.textContent.includes(this.reactProductDiscountCode) ||
        element.textContent.includes(this.giftDiscountCode),
    );

    return containsOfferDiscountCode;
  }

  #openCartDrawer() {
    const cartDrawerOpener = document.querySelector('#cart-icon-bubble');
    setTimeout(() => cartDrawerOpener.click(), 1000);
  }

  #scrollToTop() {
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
}

if (!customElements.get('always-on-reactivation')) {
  window.customElements.define('always-on-reactivation', AlwaysOnReactivation);
}
